
import { defineComponent, reactive, ref, UnwrapRef } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

interface FormState {
  email: string;
}

export default defineComponent({
  setup () {
    const router = useRouter()
    const api = process.env.VUE_APP_BASEURL
    const loading = ref<boolean>(false)

    const isSuccess = ref<boolean>(false)
    const isInvalidEmail = ref<boolean>(false)
    const hasError = ref<boolean>(false)

    const userState: UnwrapRef<FormState> = reactive({
      email: ''
    })

  
    const showLogin = () => {
      router.push('/login')
    }

    return {
      loading,
      userState,
      showLogin,
      isSuccess,
      isInvalidEmail,
      hasError
    }
  },
})
